// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Turkmenistan */
const TM = /^(?:(?:6\d|7[12])\d{6})$/;

export default TM;
